import request from '@/utils/fetch'
import * as dd from 'dingtalk-jsapi'

// 获取用户信息
export function getUserPermissionInfo() {
    return request.request({
        url: '/sys/userInfo',
        method: 'get'
    })
}
/**
 * 获取钉钉配置信息
 */
export function getConfigInfoInt() {
    return request({
        url: '/auth/dingConfig',
        method: 'get'
    })
}
/**
 * 获取token信息
 */
function getTokenInfoInter(params) {
    return request.request({
        url: '/auth/dingLogin',
        method: 'post',
        data: params
    })
}

export function getSelfInfo() {
    // 获取用户信息
    return request.request({
        url: '/sys/userInfo',
        method: 'get'
    })
}
/**
 * 通过路径token获取DDtoken信息
 */
export function getURLTokenToDDToken(mobileToken) {
    return request.request({
        url: `/auth/mobileToken`,
        method: 'post',
        data: {
            'mobileToken': mobileToken
        }
    })
}
// 获取钉钉用户信息
export function getUserInfo(params) {
    return request({
        url: '/venus/user/getUsernfo',
        method: 'post',
        data: params
    })
}
// 钉钉 返回上一个页面
export function goback() {
    return new Promise(function(resolve, reject) {
        dd.biz.navigation.goBack({
            onSuccess: function(result) {
                resolve(result)
            },
            onFail: function(err) {
                reject(err)
            }
        })
    })
}
// 钉钉 关闭当前页面
export function close() {
    return new Promise(function(resolve, reject) {
        dd.biz.navigation.close({
            onSuccess: function(result) {
                sessionStorage.removeItem('compName')
                resolve(result)
            },
            onFail: function(err) {
                reject(err)
            }
        })
    })
}
// 钉钉 设置title
export function setTitle(title) {
    return new Promise(function(resolve, reject) {
        dd.biz.navigation.setTitle({
            title,
            onSuccess: function(result) {
                resolve(result)
            },
            onFail: function(err) {
                reject(err)
            }
        })
    })
}
// 钉钉 设置title 是否显示icon
export function setIcon(flag = false) {
    return new Promise(function(resolve, reject) {
        dd.biz.navigation.setIcon({
            showIcon: flag,
            onSuccess: function(result) {
                resolve(result)
            },
            onFail: function(err) {
                reject(err)
            }
        })
    })
}
// 钉钉 设置title 是否显示icon
export function setLeft() {
    return new Promise(function(resolve, reject) {
        dd.biz.navigation.control({
            show: false, // 控制按钮显示， true 显示， false 隐藏， 默认true
            control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
            showIcon: false, // 是否显示icon，true 显示， false 不显示，默认true； 注：具体UI以客户端为准
            text: '返回', // 控制显示文本，空字符串表示显示默认文本
            onSuccess: function(result) {
                resolve(result)
            },
            onFail: function(err) {
                reject(err)
            }
        })
    })
}
// 钉钉 alert
export function message(message) {
    return new Promise(function(resolve, reject) {
        dd.device.notification.alert({
            message,
            onSuccess: function(result) {
                resolve(result)
            },
            onFail: function(err) {
                reject(err)
            }
        })
    })
}

// 通过corpId获取code
export function DDEvent() {
    return new Promise(function(resolve, reject) {
        dd.ready(function() {
            dd.runtime.permission.requestAuthCode({
                corpId: process.env.VUE_APP_CORPID,
                onSuccess: function(result) {
                    // 获取token信息
                    console.log('rrr', result)
                    let params = {
                        code: result.code,
                        appKey: process.env.VUE_APP_APPKEY,
                        appSecret: process.env.VUE_APP_APPSECRET
                    }
                    console.log('params', params)
                    getTokenInfoInter(params).then(res => {
                        console.log('auth', res)
                        sessionStorage.setItem('ddToken', res)
                        // 钉钉存储session
                        dd.util.domainStorage.setItem({
                            name: 'ddToken', // 存储信息的key值
                            value: res, // 存储信息的Value值
                            onSuccess: function(info) {
                                resolve(info)
                            },
                            onFail: function(err) {
                                console.log(err, 'fail')
                                reject(err)
                            }
                        })
                        if (res) {
                            resolve(res)
                        } else {
                            dd.device.notification.alert({
                                message: 'token为空',
                                title: '提示', // 可传空
                                buttonName: '确定'
                            })
                            reject('信息有误')
                        }
                    }).catch(error => {
                        console.error(error, 'error')
                    })
                },
                onFail: function(e) {
                    console.error(e)
                }
            })
        })
    })
}
// 飞书中登录
export function FSEvent(data) {
    return request.request({
        url: `/auth/feishuLogin`,
        method: 'post',
        data
    })
}
